import { generateTitle } from 'utils/charts/common';
import {
    GREEN_CIRCLE_URL,
    ORANGE_CIRCLE_URL,
    PINK_RED_CIRCLE_URL
} from 'utils/charts/constants';
import { OUTLIER_DETECTION_TITLE, noResultsText } from 'utils/charts/constants';

const moreThanFiveAboveThresholdGraphic = {
    image: {
        type: 'image',
        style: {
            image: GREEN_CIRCLE_URL,
            width: 12,
            height: 12,
            opacity: 0.4
        },
        cursor: 'default',
        bottom: 10,
        left: '13%'
    },
    text: {
        type: 'text',
        style: {
            text: '>5% below Threshold',
            font: '10px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        bottom: 10,
        left: '16%'
    }
};

const lessThanEqualToFivePercentBelowThresholdGraphic = {
    image: {
        type: 'image',
        style: {
            image: ORANGE_CIRCLE_URL,
            width: 12,
            height: 12
        },
        cursor: 'default',
        bottom: 10,
        left: '37%'
    },
    text: {
        type: 'text',
        style: {
            text: '\u22645% below Threshold',
            font: '10px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        bottom: 10,
        left: '40%'
    }
};

const aboveThresholdGraphic = {
    image: {
        type: 'image',
        style: {
            image: PINK_RED_CIRCLE_URL,
            width: 12,
            height: 12
        },
        cursor: 'default',
        bottom: 10,
        left: '62%'
    },
    text: {
        type: 'text',
        style: {
            text: 'Above Threshold',
            font: '10px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        bottom: 10,
        left: '65%'
    }
};

export const scenarioTwoNoResultScatterPlotOptions = () => {
    return {
        title: generateTitle(OUTLIER_DETECTION_TITLE),
        grid: {
            left: '58px',
            width: '400px',
            height: '290px',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            scale: true,
            name: '% of Portfolio Risk Mismatch Alerts',
            nameLocation: 'center',
            nameGap: 20,
            nameTextStyle: {
                color: '#7FADBF',
                fontWeight: 600,
                fontSize: 12,
                width: '100%',
                verticalAlign: 'middle'
            },
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            splitLine: {
                show: false
            }
        },
        yAxis: {
            type: 'value',
            scale: true,
            name: '% of Concentration Risk Alerts',
            nameLocation: 'center',
            nameGap: 45,
            nameTextStyle: {
                color: '#7FADBF',
                fontWeight: 600,
                fontSize: 12,
                width: '100%',
                verticalAlign: 'middle'
            },
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            splitLine: {
                show: false
            }
        },
        graphic: [
            moreThanFiveAboveThresholdGraphic.image,
            moreThanFiveAboveThresholdGraphic.text,
            lessThanEqualToFivePercentBelowThresholdGraphic.image,
            lessThanEqualToFivePercentBelowThresholdGraphic.text,
            aboveThresholdGraphic.image,
            aboveThresholdGraphic.text,
            noResultsText
        ]
    };
};
